import Vue from 'vue'

// 获取GeoJSON数据
export const getGeoJson = async (type, name) => {
  // 获取中国的geojson数据
  let data
  if (type === 'china') data = await Vue.prototype.$tkParse.get('/dir?target=china.json')

  // 获取省、直辖市、自治区的geojson数据
  if (type === 'province') data = await Vue.prototype.$tkParse.get(`/dir?target=province/${name}.json`)

  // 获取区、县的geojson数据
  if (type === 'city') data = await Vue.prototype.$tkParse.get(`/dir?target=city/${name}.json`)
  return data
}
